import { useEffect, useState, useRef, useMemo } from "react";
import axios from "axios";
import { Button } from "../components/ui/button";
import { Checkbox } from "../components/ui/checkbox";
import { toast } from "sonner";
import { Download, QrCode, Loader2, Printer } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LOGO_URL = "https://customer-assets.emergentagent.com/job_75f76eb1-ed0f-4a2e-8af9-a573c953ed2b/artifacts/jcb4nruu_7d3b96f2-f08e-453b-8c2c-591199068bb4.jpeg";

function loadScript(src) {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) return resolve();
    const s = document.createElement("script");
    s.src = src; s.onload = resolve; s.onerror = reject;
    document.head.appendChild(s);
  });
}

const ROLE_LABELS = {
  admin: "Administrador", operator: "Operador de Injeção",
  quality: "Qualidade", shift_leader: "Chefe de Turno", display: "Ecrã",
};

const qrImg = (token) =>
  `https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${encodeURIComponent(token)}&margin=0`;

/* --------- LARGE CARD (preview + PNG download, 800x500) --------- */
function Card({ user, qrToken, cardRef }) {
  const roleLabel = ROLE_LABELS[user.role] || user.role;
  return (
    <div ref={cardRef} className="badge-card" style={{
      width: 800, height: 500, position: "relative", background: "#fff",
      fontFamily: "Arial, sans-serif", overflow: "hidden", borderRadius: 12, boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    }}>
      <img src={LOGO_URL} alt="" style={{ position: "absolute", top: 24, left: 32, height: 70 }} crossOrigin="anonymous" />
      <div style={{ position: "absolute", top: 105, left: 32, right: 400, fontSize: 11, color: "#94a3b8", letterSpacing: 1.5 }}>
        INJEÇÃO DE PLÁSTICOS • DESENVOLVIMENTO DE PRODUTO • MOLDES
      </div>
      <div style={{
        position: "absolute", top: 140, left: 0, width: 430, height: 260,
        background: "#0b1f3a", clipPath: "polygon(0 0, 90% 0, 100% 50%, 90% 100%, 0 100%)",
      }} />
      {user.photo_url ? (
        <img src={user.photo_url} alt="" crossOrigin="anonymous" style={{
          position: "absolute", top: 155, left: 20, width: 175, height: 230, objectFit: "cover",
          border: "3px solid #f97316", borderRadius: 6,
        }} />
      ) : (
        <div style={{ position: "absolute", top: 155, left: 20, width: 175, height: 230, background: "#334155",
          borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center",
          color: "#fff", fontSize: 60, fontWeight: 700, border: "3px solid #f97316" }}>
          {(user.name || "?").charAt(0)}
        </div>
      )}
      <div style={{ position: "absolute", top: 200, left: 210, color: "#fff", width: 210 }}>
        <div style={{ fontSize: 22, fontWeight: 900, lineHeight: 1.1, textTransform: "uppercase" }}>{user.name}</div>
        <div style={{ height: 3, width: 40, background: "#f97316", margin: "6px 0" }} />
        <div style={{ fontSize: 13, fontWeight: 700, color: "#f97316", textTransform: "uppercase" }}>{user.function || roleLabel}</div>
        <div style={{ fontSize: 11, marginTop: 20, color: "#cbd5e1" }}>Nº DE OPERADOR</div>
        <div style={{ fontSize: 28, fontWeight: 900, color: "#f97316" }}>{user.user_code}</div>
      </div>
      <div style={{ position: "absolute", top: 155, left: 450, right: qrToken ? 180 : 24, color: "#0b1f3a" }}>
        {[
          ["NOME", user.name],
          ["N° DE OPERADOR", user.user_code],
          ["FUNÇÃO", user.function || roleLabel],
          ["DATA DE ADMISSÃO", user.admission_date || "-"],
          ["DEPARTAMENTO", user.department || "-"],
        ].map(([label, value], i) => (
          <div key={i} style={{ marginBottom: 6 }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: "#64748b" }}>{label}</div>
            <div style={{ fontSize: 13, fontWeight: 600, borderBottom: "1px solid #e2e8f0", paddingBottom: 2 }}>{value || "-"}</div>
          </div>
        ))}
      </div>
      {qrToken && (
        <div style={{ position: "absolute", top: 20, right: 20, textAlign: "center" }}>
          <img src={qrImg(qrToken)} alt="QR" crossOrigin="anonymous" style={{ width: 120, height: 120, border: "3px solid #0b1f3a", borderRadius: 4 }} />
          <div style={{ background: "#0b1f3a", color: "#fff", fontSize: 9, padding: "3px 6px", borderRadius: 10, marginTop: 4, display: "inline-block" }}>
            🌐 www.engenharia3d.pt
          </div>
        </div>
      )}
      <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: 100, background: "#0b1f3a", color: "#fff", padding: "14px 24px" }}>
        <div style={{ display: "flex", justifyContent: "space-around", fontSize: 10 }}>
          <div style={{ textAlign: "center" }}><div style={{ color: "#f97316" }}>✓</div>QUALIDADE<br/>E COMPROMISSO</div>
          <div style={{ textAlign: "center" }}><div style={{ color: "#f97316" }}>⚙</div>INOVAÇÃO<br/>E TECNOLOGIA</div>
          <div style={{ textAlign: "center" }}><div style={{ color: "#f97316" }}>👥</div>TRABALHO<br/>EM EQUIPA</div>
          <div style={{ textAlign: "center", fontSize: 9, maxWidth: 200 }}>
            <div style={{ fontWeight: 700 }}>ESTE CARTÃO É PESSOAL E INTRANSMISSÍVEL</div>
            <div style={{ opacity: 0.8, marginTop: 2 }}>Em caso de perda ou roubo, entregue na receção.</div>
          </div>
        </div>
        <div style={{ borderTop: "1px solid #f97316", marginTop: 8, paddingTop: 6, display: "flex", justifyContent: "space-around", fontSize: 10, color: "#f97316" }}>
          <span>🌐 www.engenharia3d.pt</span>
          <span>📞 931 666 081</span>
          <span>📍 Santarém, Portugal</span>
        </div>
      </div>
    </div>
  );
}

/* --------- MINI CARD (A4 print, ~90x65mm, half business-card) --------- */
function MiniCard({ user, qrToken }) {
  const roleLabel = ROLE_LABELS[user.role] || user.role;
  return (
    <div className="mini-badge">
      <div className="mini-header">
        <img src={LOGO_URL} alt="EP3D" className="mini-logo" crossOrigin="anonymous" />
        <div className="mini-tagline">INJEÇÃO • MOLDES • PRODUTO</div>
      </div>
      <div className="mini-body">
        {user.photo_url ? (
          <img src={user.photo_url} alt="" className="mini-photo" crossOrigin="anonymous" />
        ) : (
          <div className="mini-photo mini-photo-fallback">{(user.name || "?").charAt(0)}</div>
        )}
        <div className="mini-info">
          <div className="mini-name">{user.name}</div>
          <div className="mini-role">{user.function || roleLabel}</div>
          <div className="mini-meta"><span>N.º</span> <b>{user.user_code}</b></div>
          <div className="mini-meta"><span>Dep.</span> <b>{user.department || "-"}</b></div>
        </div>
        {qrToken && (
          <img src={qrImg(qrToken)} alt="QR" className="mini-qr" crossOrigin="anonymous" />
        )}
      </div>
      <div className="mini-footer">
        <span>engenharia3d.pt</span>
        <span>Santarém, PT</span>
      </div>
    </div>
  );
}

export default function QrBadges() {
  const [users, setUsers] = useState([]);
  const [tokens, setTokens] = useState({});
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(null);
  const [bulkBusy, setBulkBusy] = useState(false);
  const [selected, setSelected] = useState({});
  const refs = useRef({});

  const load = async () => {
    try {
      const r = await axios.get(`${API}/users`);
      const list = r.data.filter(u => u.role !== "display");
      setUsers(list);
      // pre-populate tokens for users that already have one
      const existing = {};
      list.forEach(u => { if (u.qr_login_token) existing[u.id] = u.qr_login_token; });
      setTokens(existing);
    } catch (e) { toast.error("Erro ao carregar utilizadores"); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const generateQr = async (userId) => {
    setBusy(userId);
    try {
      const r = await axios.post(`${API}/auth/qr-token/generate/${userId}`);
      setTokens(prev => ({ ...prev, [userId]: r.data.qr_token }));
      toast.success(`QR gerado para ${r.data.name || r.data.user_code}`);
    } catch (e) { toast.error(e?.response?.data?.detail || "Erro"); }
    finally { setBusy(null); }
  };

  const downloadCard = async (userId) => {
    if (!tokens[userId]) { toast.error("Gere o QR primeiro"); return; }
    setBusy(userId);
    try {
      await loadScript("https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js");
      const el = refs.current[userId];
      const canvas = await window.html2canvas(el, { scale: 2, useCORS: true, backgroundColor: "#fff" });
      const link = document.createElement("a");
      link.download = `Cracha-${users.find(u => u.id === userId)?.user_code || userId}.png`;
      link.href = canvas.toDataURL("image/png");
      link.click();
      toast.success("Imagem gerada");
    } catch (e) { toast.error("Erro ao gerar imagem"); }
    finally { setBusy(null); }
  };

  const selectedIds = useMemo(() => users.filter(u => selected[u.id]).map(u => u.id), [users, selected]);
  const toggleAll = () => {
    if (selectedIds.length === users.length) setSelected({});
    else { const all = {}; users.forEach(u => { all[u.id] = true; }); setSelected(all); }
  };

  const printSheet = async () => {
    if (selectedIds.length === 0) { toast.error("Selecione pelo menos 1 colaborador"); return; }
    setBulkBusy(true);
    try {
      // Generate QR for selected users that don't have one yet
      const missing = selectedIds.filter(id => !tokens[id]);
      if (missing.length > 0) {
        toast.info(`A gerar ${missing.length} QRs em falta...`);
        const newTokens = {};
        for (const id of missing) {
          try {
            const r = await axios.post(`${API}/auth/qr-token/generate/${id}`);
            newTokens[id] = r.data.qr_token;
          } catch (e) { /* skip */ }
        }
        setTokens(prev => ({ ...prev, ...newTokens }));
        await new Promise(res => setTimeout(res, 400));
      }
      // Wait a tick so DOM re-renders with QR images
      await new Promise(res => setTimeout(res, 800));
      window.print();
    } finally { setBulkBusy(false); }
  };

  if (loading) return <div className="flex justify-center p-10"><Loader2 className="h-6 w-6 animate-spin" /></div>;

  const selectedUsers = users.filter(u => selected[u.id]);

  return (
    <div className="space-y-6" data-testid="qr-badges-page">
      <style>{`
        /* Screen: hide print sheet */
        .print-sheet { display: none; }

        @media print {
          @page { size: A4 portrait; margin: 8mm; }
          body * { visibility: hidden !important; }
          .print-sheet, .print-sheet * { visibility: visible !important; }
          .print-sheet {
            display: grid !important;
            grid-template-columns: 1fr 1fr;
            gap: 4mm;
            position: absolute; left: 0; top: 0; width: 100%;
          }
          .mini-badge { page-break-inside: avoid; break-inside: avoid; }
          .mini-badge:nth-child(8n) { page-break-after: always; break-after: page; }
        }

        .mini-badge {
          width: 92mm;
          height: 65mm;
          border: 1px dashed #94a3b8;
          background: #fff;
          font-family: Arial, sans-serif;
          color: #0b1f3a;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          border-radius: 3mm;
        }
        .mini-header {
          background: #0b1f3a;
          color: #fff;
          padding: 2mm 3mm;
          display: flex;
          align-items: center;
          gap: 3mm;
          height: 10mm;
        }
        .mini-logo { height: 6mm; background: #fff; border-radius: 1mm; padding: 0.5mm; }
        .mini-tagline { font-size: 6pt; letter-spacing: 1px; color: #f97316; font-weight: 700; }
        .mini-body {
          flex: 1;
          padding: 2mm 3mm;
          display: grid;
          grid-template-columns: 22mm 1fr 20mm;
          gap: 2mm;
          align-items: center;
        }
        .mini-photo {
          width: 22mm; height: 28mm; object-fit: cover;
          border: 0.6mm solid #f97316; border-radius: 1.5mm; background: #334155;
        }
        .mini-photo-fallback {
          display: flex; align-items: center; justify-content: center;
          color: #fff; font-size: 22pt; font-weight: 900;
        }
        .mini-info { min-width: 0; }
        .mini-name {
          font-size: 10pt; font-weight: 900; text-transform: uppercase;
          line-height: 1.1; margin-bottom: 1mm;
          overflow: hidden; text-overflow: ellipsis;
        }
        .mini-role {
          font-size: 7pt; font-weight: 700; color: #f97316;
          text-transform: uppercase; margin-bottom: 1.5mm;
        }
        .mini-meta { font-size: 7pt; margin-top: 0.5mm; color: #475569; }
        .mini-meta b { color: #0b1f3a; font-weight: 800; margin-left: 0.5mm; }
        .mini-qr {
          width: 20mm; height: 20mm; border: 0.5mm solid #0b1f3a; border-radius: 0.5mm;
        }
        .mini-footer {
          background: #0b1f3a;
          color: #f97316;
          padding: 1.2mm 3mm;
          display: flex;
          justify-content: space-between;
          font-size: 6pt;
          font-weight: 700;
        }
      `}</style>

      <div className="flex items-start justify-between flex-wrap gap-4">
        <div>
          <h1 className="text-3xl font-bold flex items-center gap-2"><QrCode className="h-8 w-8 text-blue-600" /> Crachás com QR</h1>
          <p className="text-sm text-muted-foreground mt-1">
            Gere e descarregue crachás individuais ou imprima uma folha A4 com 8 crachás.
            Os dados provêm do registo de colaboradores (nome, função, departamento, foto).
          </p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" onClick={toggleAll} data-testid="toggle-all-btn">
            {selectedIds.length === users.length ? "Desmarcar todos" : "Selecionar todos"}
          </Button>
          <Button
            className="bg-blue-600 hover:bg-blue-700"
            onClick={printSheet}
            disabled={bulkBusy || selectedIds.length === 0}
            data-testid="print-sheet-btn"
          >
            {bulkBusy ? <Loader2 className="h-4 w-4 animate-spin mr-1" /> : <Printer className="h-4 w-4 mr-1" />}
            Imprimir A4 ({selectedIds.length} selecionados)
          </Button>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-6">
        {users.map(u => (
          <div key={u.id} className="bg-white p-4 rounded-lg border shadow-sm">
            <div className="flex justify-between items-start mb-3 gap-4">
              <label className="flex items-center gap-3 cursor-pointer flex-1">
                <Checkbox
                  checked={!!selected[u.id]}
                  onCheckedChange={(v) => setSelected(prev => ({ ...prev, [u.id]: !!v }))}
                  data-testid={`select-${u.user_code}`}
                />
                <div>
                  <div className="font-bold">{u.name} <span className="text-sm text-gray-500 ml-2">{u.user_code}</span></div>
                  <div className="text-xs text-gray-500">
                    {u.function || ROLE_LABELS[u.role] || u.role} · {u.department || "sem departamento"}
                    {tokens[u.id] && <span className="ml-2 text-emerald-600 font-semibold">✓ QR gerado</span>}
                  </div>
                </div>
              </label>
              <div className="flex gap-2">
                <Button size="sm" variant="outline" onClick={() => generateQr(u.id)} disabled={busy === u.id} data-testid={`gen-qr-${u.user_code}`}>
                  {busy === u.id ? <Loader2 className="h-4 w-4 animate-spin mr-1" /> : <QrCode className="h-4 w-4 mr-1" />}
                  {tokens[u.id] ? "Regenerar" : "Gerar QR"}
                </Button>
                {tokens[u.id] && (
                  <Button size="sm" className="bg-emerald-600 hover:bg-emerald-700" onClick={() => downloadCard(u.id)} disabled={busy === u.id} data-testid={`download-${u.user_code}`}>
                    {busy === u.id ? <Loader2 className="h-4 w-4 animate-spin mr-1" /> : <Download className="h-4 w-4 mr-1" />}
                    PNG Individual
                  </Button>
                )}
              </div>
            </div>
            <div className="flex justify-center overflow-x-auto">
              <Card user={u} qrToken={tokens[u.id]} cardRef={(el) => (refs.current[u.id] = el)} />
            </div>
          </div>
        ))}
      </div>

      {/* Print-only sheet: 8 badges per A4 (2 cols x 4 rows) */}
      <div className="print-sheet" data-testid="print-sheet">
        {selectedUsers.map(u => (
          <MiniCard key={u.id} user={u} qrToken={tokens[u.id]} />
        ))}
      </div>
    </div>
  );
}
